export default {
  seeAllLinkLabel: 'ActionSeeAll',
  leftScroller: 'scroller prev',
  rightScroller: 'scroller next',
  leftScrollIcon: 'icon-games-carousel-left',
  rightScrollIcon: 'icon-games-carousel-right',
  carouselScrollStartPoint: {
    left: '0px'
  },
  currentPageLayout: {
    numberOfGamesFetched: 0,
    numberOfGamesScrolled: 0,
    isGridLayoutDisabled: false
  },
  seeAllClass:
    'see-all-button games-filter-changer btn-min-width btn-secondary-xs btn-more see-all-link-icon',
  pageType: {
    gameCarousel: 'Games',
    gameSearch: 'GameSearch',
    gameSeeAll: 'GamesSeeAll'
  },
  numberOfGameRendering: 60,
  thresholdOfMaxNumOfGamesForSort: 60,
  sortStyle: {
    featureGameTile: 'featured-tile',
    featureGameTileSmallIcon: 'featured-tile-small-icon'
  }
};
